import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import Navbar from "components/Navbars/AuthNavbar.js";
import ShowExamples from "components/Analysis/ShowExamples";
import Footer from "components/Footers/Footer";
import filesService from "services/files.service.js";

export default function Landing() {
  const [subastaQuery, setSubastaQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const navigate = useNavigate();

  const handleStartAnalysis = (e) => {
    e.preventDefault();
    if (!subastaQuery) return;

    let idSub = subastaQuery.trim();

    // Robust extraction of idSub
    try {
      if (idSub.includes("idSub=")) {
        const urlPart = idSub.split("idSub=")[1];
        // Take everything until the next & or the end of the string
        idSub = urlPart.split("&")[0];
      } else if (idSub.includes("subasta.php?id=")) { // Another potential format
          const urlPart = idSub.split("id=")[1];
          idSub = urlPart.split("&")[0];
      }
      
      // Clean up any remaining hash or junk
      idSub = idSub.split("#")[0];
    } catch (err) {
      console.error("Error parsing input string, using original value");
    }

    if (idSub) {
      navigate(`/subasta?idSub=${encodeURIComponent(idSub)}`);
    }
  };


  return (
    <>
      <Navbar transparent />
      <main>
        <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover bg-blueGray-100"
          >
          </div>

          <div className="container relative mx-auto">
            <div className="items-center flex flex-wrap flex-col md:flex-row">
              <div className="w-full md:w-2/3 px-4 pt-16 ml-auto mr-auto text-center justify-center items-center">
                <h1 className="text-sky-900 font-semibold text-5xl text-left">
                  Analiza subastas del BOE fácil y rápido
                </h1>
                <p className="mt-10 text-xl text-left">
                  Las subastas del BOE pueden ser auténticas minas de gangas… o trampas en las que perder dinero. Si no investigas antes de pujar, podrías acabar comprando algo que te saldrá más caro de lo esperado.
                  <br />
                  Nuestra IA analiza subastas por tí para que, en pocos minutos, puedas decidir si una subasta es una buena oportunidad o si es mejor dejarla pasar.
                </p>
                <div className='flex flex-col gap-4 mt-6'>
                  <p className="text-xl text-left">
                    <span className="font-semibold mr-1">🛡 Evita riesgos y sorpresas.</span>
                    Detecta cargas ocultas antes de que te cuesten dinero.
                  </p>
                  <p className="text-xl text-left">
                    <span className="font-semibold mr-1">📄 Resumen claro y directo.</span>
                    Olvídate de leer largas notas simples.
                  </p>
                  <p className="text-xl text-left">
                    <span className="font-semibold mr-1">💰 Aprovecha las mejores ofertas.</span>
                    Identifica las subastas más rentables como un experto.
                  </p>
                </div>

                <div className="mt-10 w-full max-w-lg">
                  <form onSubmit={handleStartAnalysis} className="relative flex flex-col sm:flex-row items-center gap-2">
                    <div className="relative w-full">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <i className="fas fa-search text-gray-400"></i>
                      </div>
                      <input
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-4 shadow-lg pr-4"
                        placeholder="Pega el enlace del BOE o código de subasta..."
                        value={subastaQuery}
                        onChange={(e) => setSubastaQuery(e.target.value)}
                        required
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={isSearching}
                      className="w-full sm:w-auto text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 font-bold rounded-lg text-lg px-8 py-4 text-center transition-all transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSearching ? (
                        <>
                          <i className="fas fa-spinner animate-spin mr-2"></i>
                          BUSCANDO...
                        </>
                      ) : (
                        "ANALIZAR"
                      )}
                    </button>
                  </form>
                  <p className="text-xs text-left mt-2 text-gray-500 ml-1 italic">
                    Ejemplo: SUB-JA-2022-205009 o el enlace completo de la subasta.
                  </p>
                </div>
              </div>
              <div className="w-full md:w-1/3 px-4 pt-16 ml-auto mr-auto text-center justify-center items-center">
                <ShowExamples />
              </div>
            </div>
          </div>
        </div>

      </main>
      <Footer />
    </>
  );
}